<template>
  <div class="empty-container" :style="{'width':width, 'height':height}">
    <div class="empty-component">
      <img src="../../assets/images/monitorRecord/bg-empty.png" alt="" />
      <div class="tips">{{tips}}</div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '408px'
        },
        tips: {
            type: String,
            default: '暂无数据'
        }
    }
};
</script>

<style lang='scss' scoped>
.empty-container {
  width: 100%;
  height: 500px;
  .empty-component {
    width: 100%;
    height: 100%;
    flex-direction: column;
    background-color: #f2f2f2;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-bottom: 21px;
      width: 251px;
      height: 180px;
      opacity: 0.64;
    }
    .tips {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #999999;
      line-height: 22px;
    }
  }
}
</style>